
/**
 * 강의 콘텐츠 지원 플랫폼
 */
export type GetCourseDetail200SectionsItemLecturesItemPlatformSupport = typeof GetCourseDetail200SectionsItemLecturesItemPlatformSupport[keyof typeof GetCourseDetail200SectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDetail200SectionsItemLecturesItemPlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
  UNKNOWN: 'UNKNOWN',
} as const;
